import { render, staticRenderFns } from "./PredictedCategorySections.vue?vue&type=template&id=67b70c6b&scoped=true&"
import script from "./PredictedCategorySections.vue?vue&type=script&lang=js&"
export * from "./PredictedCategorySections.vue?vue&type=script&lang=js&"
import style0 from "./PredictedCategorySections.vue?vue&type=style&index=0&id=67b70c6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b70c6b",
  null
  
)

export default component.exports